import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ColType, Condition } from '@/lib/utils.type'
import { SiteListDataProps } from '@/services/types/api.types'
import { DeviceNode } from '@/containers/TechnologyAndNetwork/siteDetails/ActiveDevices/activeDevices'

type FilterPayload = {
  fields: string[]
  conditions: Record<string, unknown>[]
}

export interface SiteDetails {
  value: string
  Id: string
  label: string
  Rev_io_Account_ID__c: string
}

type SiteListState = {
  accessorKey: string
  siteListTableData: SiteListDataProps[]
  isLoading: boolean
  filterPayload: FilterPayload
  services: Record<string, unknown>
  tableHeaders: ColType[]
  activeTableHeaders: ColType[]
  defaultTableHeaders: ColType[]
  navigatedSite: SiteDetails
  device: Record<string, unknown>
  activeDevices: DeviceNode[]
  activefilterConditions: Condition[]
}

const initialState: SiteListState = {
  accessorKey: 'IsClosed',
  siteListTableData: [],
  isLoading: true,
  filterPayload: { fields: [], conditions: [] },
  services: {},
  tableHeaders: [
    { name: 'NAME', label: 'Name' },
    { name: 'STATUS', label: 'Status' },
    { name: 'OPEN_CASE_COUNT', label: 'Open Case Count' },
    { name: 'BILLING_ADDRESS', label: 'Billing Address' },
  ],
  activeTableHeaders: [],
  defaultTableHeaders: [
    { name: 'NAME', label: 'Name' },
    { name: 'STATUS', label: 'Status' },
    { name: 'OPEN_CASE_COUNT', label: 'Open Case Count' },
    { name: 'BILLING_ADDRESS', label: 'Billing Address' },
  ],
  device: {},
  navigatedSite: {
    value: '',
    Id: '',
    label: '',
    Rev_io_Account_ID__c: '',
  },
  activeDevices: [],
  activefilterConditions: [],
}

const siteListSlice = createSlice({
  name: 'siteList',
  initialState,
  reducers: {
    setTableHeaders: (state, action: PayloadAction<ColType[]>) => {
      state.tableHeaders = action.payload
    },
    setActiveTableHeaders: (state, action: PayloadAction<ColType[]>) => {
      state.activeTableHeaders = action.payload
    },
    setDefaultTableHeaders: (state, action: PayloadAction<ColType[]>) => {
      state.defaultTableHeaders = action.payload
    },
    setSiteListTableData: (
      state,
      action: PayloadAction<SiteListDataProps[]>,
    ) => {
      state.siteListTableData = action.payload
    },
    setFilterPayload: (state, action: PayloadAction<FilterPayload>) => {
      state.filterPayload = action.payload
    },
    isLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setActiveFilterConditions: (state, action: PayloadAction<Condition[]>) => {
      state.activefilterConditions = action.payload
    },
    setActiveDevices: (state, action: PayloadAction<DeviceNode[]>) => {
      state.activeDevices = action.payload
    },
    setServices: (state, action: PayloadAction<Record<string, unknown>>) => {
      state.services = action.payload
    },
    setNavigatedSite: (state, action: PayloadAction<SiteDetails>) => {
      state.navigatedSite = action.payload
    },
    setDev: (state, action: PayloadAction<Record<string, unknown>>) => {
      state.device = action.payload
    },
  },
})

export const {
  setTableHeaders,
  setActiveTableHeaders,
  setDefaultTableHeaders,
  setSiteListTableData,
  isLoading,
  setFilterPayload,
  setActiveFilterConditions,
  setActiveDevices,
  setServices,
  setNavigatedSite,
  setDev,
} = siteListSlice.actions

export default siteListSlice.reducer
